export default "__VITE_ASSET__daa9a05e__"